import { initStore } from './redux/store'

// Init prelim stuff
export const { store, persistor } = initStore()
